import { ITEM_REQUIRED_FEATURE_FLAGS, SECTION_REQUIRED_FEATURE_FLAGS } from '../config/featureFlags';
import type { BtlApplication } from '@api/btlApplicationForm/types';
import type { CaseSidebarFeatureFlags } from '../types';
import { CaseSidebarItemId, CaseSidebarSection } from '../types';

function areRequiredFeatureFlagsEnabled(
  requiredFlags: string[] | undefined,
  featureFlags: CaseSidebarFeatureFlags,
): boolean {
  if (!requiredFlags?.length) {
    return true;
  }

  return requiredFlags.every(flag => featureFlags[flag] === true);
}

export function isItemVisible(
  itemId: CaseSidebarItemId,
  section: CaseSidebarSection,
  application: BtlApplication,
  featureFlags: CaseSidebarFeatureFlags,
): boolean {
  if (!areRequiredFeatureFlagsEnabled(SECTION_REQUIRED_FEATURE_FLAGS[section], featureFlags)) {
    return false;
  }

  if (!areRequiredFeatureFlagsEnabled(ITEM_REQUIRED_FEATURE_FLAGS[itemId], featureFlags)) {
    return false;
  }

  if (itemId === CaseSidebarItemId.TOP_SLICING && application.isTopSlicing !== true) {
    return false;
  }

  return true;
}
